import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";
import * as Turbo from "@hotwired/turbo";

export default class extends Controller {
  static values = {
    group: String,
    resourceName: String,
    containerPrefix: { type: String, default: "" },
    urlSegment: { type: String, default: "" },
  };

  connect() {
    if (Sortable.active) return;
    this.initSortable();
  }

  disconnect() {
    if (Sortable.active) return;
    if (this.sortable) {
      this.sortable.destroy();
      this.sortable = null;
    }
  }

  initSortable() {
    if (this.sortable) {
      this.sortable.destroy();
    }
    this.sortable = Sortable.create(this.element, {
      group: this.hasGroupValue ? this.groupValue : undefined,
      handle: "[data-sortable-handle]",
      animation: 150,
      ghostClass: "opacity-30",
      draggable: "[data-sortable-id]",
      onEnd: this.onEnd.bind(this),
    });
  }

  getParentId(to) {
    const prefix = this.containerPrefixValue;
    if (prefix && to.id.startsWith(prefix)) {
      return to.id.replace(prefix, "");
    }
    return null;
  }

  getUrlWithNewSectionId(reorderUrl, newSectionId) {
    const segment = this.urlSegmentValue;
    if (segment && newSectionId) {
      const regex = new RegExp(`\\/${segment}\\/\\d+\\/`);
      return reorderUrl.replace(regex, `/${segment}/${newSectionId}/`);
    }
    return reorderUrl;
  }

  onEnd(event) {
    const { item, newIndex, from, to } = event;
    const id = item.dataset.sortableId;
    const reorderUrl = item.dataset.sortableReorderUrl;

    if (!id || !reorderUrl) return;

    const params = new URLSearchParams({ position: newIndex });

    if (from !== to && this.hasGroupValue) {
      const parentId = this.getParentId(to);
      if (parentId) {
        params.append("new_section_id", parentId);
      }
    }

    const csrfToken = document.querySelector(
      'meta[name="csrf-token"]',
    )?.content;

    let url = reorderUrl;

    if (from !== to && this.hasGroupValue) {
      const parentId = this.getParentId(to);
      url = this.getUrlWithNewSectionId(reorderUrl, parentId);
    }

    fetch(url, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Accept": "text/vnd.turbo-stream.html",
        "X-CSRF-Token": csrfToken,
      },
      body: params.toString(),
    })
      .then((response) => {
        if (!response.ok) {
          console.error("Sortable: Reorder failed", response.status);
          return;
        }
        return response.text();
      })
      .then((html) => {
        if (html) Turbo.renderStreamMessage(html);
      });
  }
}
